import qs from 'qs';
import axiosClient from './axiosClient';
import { serviceBase } from './serviceBase';

const getContractActionsList = serviceBase({
  request: options =>
    axiosClient.get('/contracts/actions', {
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      }
    }),
  retry: 0
});

export const downloadContractActionsExport = serviceBase({
  request: options =>
    axiosClient.get('/contracts/actions/export', {
      responseType: 'blob',
      params: options,
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      timeout: 120000
    }),
  transformResponse: res => {
    try {
      const filename = 'Eventos de contratos.xlsx';
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(res.data);
      a.download = filename;
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
    } catch (error) {
      console.log(`Opps, un error: ${error}`);
      console.error(error);
    }
  },
  retry: 0
});

export default getContractActionsList;
